
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCloseGoogle as ObiCloseGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-close-google.js';
 
 
 

 
 export const ObiCloseGoogle = createComponent({
   react: React,
   tagName: 'obi-close-google',
   elementClass: ObiCloseGoogleElement,
   events: {
     
   }
  });
 
 